import * as Yup from 'yup';
import PropTypes from 'prop-types';


export const ReceiptYupSchema = Yup.object().shape({
    mode: Yup.string().required('Required'),
    date: Yup.string().required('Required'),
    amount: Yup.number().required('Required'),
});

export const PaymentYupSchema = Yup.object().shape({
    mode: Yup.string().required('Required'),
    date: Yup.string().required('Required'),
    amount: Yup.number().required('Required'),

});